import { authService } from 'auth/services';
import { formatDate } from 'features/order-tracker/utils';
import {
  MILESTONE_STATUSES,
  PRODUCT_NAMES,
  SERVICE_ACTIVATION_PRODUCTS_TYPES,
} from 'features/order-tracker/utils/entries';

import { SERVICE_ACTIVATION_TITLE } from './constants';

export const isDateInFuture = (date: string): boolean => new Date(date).getTime() >= new Date().setHours(0, 0, 0, 0);
export const isDateInPast = (date: string): boolean => new Date(date).getTime() < new Date().setHours(0, 0, 0, 0);
export const isEstimationCompletionDatesExist = (products: transformedResponse.ServiceProduct[]): boolean =>
  products.every((product) => product.estimatedCompletionDate !== undefined);

export const isSomeDateInPresentOrFuture = (products: transformedResponse.ServiceProduct[]): boolean =>
  products.some((product) => isDateInFuture(product.estimatedCompletionDate));

export const isSomeDateInPast = (products: transformedResponse.ServiceProduct[]): boolean =>
  products.some((product) => isDateInPast(product.estimatedCompletionDate));

export const isSameDates = (firstDate: string, secondDate: string): boolean =>
  new Date(firstDate).setHours(0, 0, 0, 0) === new Date(secondDate).setHours(0, 0, 0, 0);

export const isSameEstimatedCompletionDates = (products: transformedResponse.ServiceProduct[]): boolean => {
  if (products.length !== 2) {
    return false;
  }

  return isSameDates(products[0].estimatedCompletionDate, products[1].estimatedCompletionDate);
};

export const formatMilestone = (
  product: transformedResponse.ServiceProduct,
  isAppointed: boolean,
  type: string,
): common.OrderMilestone => {
  const isAuthenticated = authService.isAuthenticated();

  const { estimatedCompletionDate, productName, installationAddress } = product;
  const isWithAppointment = productName === PRODUCT_NAMES.BBProduct && isAppointed;
  let productStatus;

  const isCompleted = !isDateInFuture(estimatedCompletionDate);

  if (isWithAppointment) {
    productStatus = type || SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAppointment;
  } else {
    productStatus = type || productName;
  }

  const formattedAddress = isAuthenticated ? installationAddress : `Postcode: ${installationAddress}`;
  const formattedStatus = isCompleted ? `${productStatus}Completed` : `${productStatus}Incomplete`;
  let title = SERVICE_ACTIVATION_TITLE[type || productStatus];
  if (
    type === SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAppointmentAndCVE ||
    type === SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAndCVE ||
    type === SERVICE_ACTIVATION_PRODUCTS_TYPES.nonHalo
  ) {
    if (productName.includes('Broadband')) {
      title = SERVICE_ACTIVATION_TITLE[PRODUCT_NAMES.BBProduct];
    } else if (productName.includes('Cloud')) {
      title = SERVICE_ACTIVATION_TITLE[PRODUCT_NAMES.CVEProduct];
    }
  }
  return {
    renderKey:`${formattedStatus}${title}${productName}`,
    id: formattedStatus,
    formattedDate: formatDate('dddd D MMMM YYYY', estimatedCompletionDate),
    milestoneStatus: isCompleted ? MILESTONE_STATUSES.complete : MILESTONE_STATUSES.incomplete,
    status: formattedStatus,
    title,
    subTitle: formattedAddress,
    displayTitle: title,
    productName,
    isAppAndPhoneCVE:product?.isAppAndPhoneCVE,
    isAppOnlyCVE:product?.isAppOnlyCVE,
  };
};

export const getServiceActivationMilestones = (
  orderStatus: string,
  CVEProducts: transformedResponse.ServiceProduct[],
  BBProducts: transformedResponse.ServiceProduct[],
): common.OrderMilestone[] => {
  const isSuitableAmountOfProducts =
    (BBProducts.length || CVEProducts.length) && BBProducts.length <= 1 && CVEProducts.length <= 1;

  if (!isSuitableAmountOfProducts) return [];

  const { engineeringAppointmentDate = '', estimatedCompletionDate = '', isShowAppointment } = BBProducts[0] || {};

  const isAppointed = !!engineeringAppointmentDate && isSameDates(engineeringAppointmentDate, estimatedCompletionDate);

  let products = isAppointed && isShowAppointment === false ? [...CVEProducts] : [...BBProducts, ...CVEProducts];
  
  const isKCI2Assure =  [...BBProducts, ...CVEProducts].some((product) =>product.FTTPInstallProcess === 'KCI2 Assure');
  if(isKCI2Assure){
    products =[];
  }

  const isAllProductsHasEstimatedCompletionDate = isEstimationCompletionDatesExist(products);

  if (!isAllProductsHasEstimatedCompletionDate) return [];

  // const isShowServiceActivationMilestone =
  //   isSomeDateInPresentOrFuture(products) || orderStatus === ORDER_STATUS_COMPLETED;

  // if (!isShowServiceActivationMilestone) return [];


  let type;

  if (!products[0]?.isHALO) {
    type = SERVICE_ACTIVATION_PRODUCTS_TYPES.nonHalo;
  }

  const isSameDate = isSameEstimatedCompletionDates(products);


  if (isSameDate) {
    type = isAppointed
      ? SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAppointmentAndCVE
      : SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAndCVE;
    // products.splice(1, 1);
  }

  /* eslint-disable-next-line no-plusplus */
  for(let i= 0 ; i<=products.length; i++){
    if(products[i]?.OrderStatus!=='Completed' && isDateInPast(products[i]?.estimatedCompletionDate)){
      products.splice(i, 1);
      /* eslint-disable-next-line no-plusplus */
      i--;
    }
  }


  return products.map((product) =>
    formatMilestone(product, isAppointed, type)
  );
};
